export const CRITICAL_WORKFLOW_PAIN_WINDOW_VITAL_NAME =
  'critical_workflow_pain_window';
export const DEFAULT_CRITICAL_WORKFLOW_PAIN_WINDOW_DURATION_MS = 4_000;
// Maximum configured measurement length. A frame that starts before this limit
// and finishes afterward is counted in full, extending the reported duration.
export const MAX_PAIN_OBSERVATION_DURATION_MS = 60_000;
